'use client';

import { useEffect } from 'react';

const DUPLICATE_WINDOW_MS = 10 * 60_000;

export function AlertLoopGuard() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if ((window as any).__snapgridAlertLoopGuardInstalled) return;

    const nativeAlert = window.alert.bind(window);
    const recentAlerts = new Map<string, number>();

    window.alert = (message?: any) => {
      const text = String(message ?? '');
      const now = Date.now();
      const lastShownAt = recentAlerts.get(text) ?? 0;

      if (now - lastShownAt < DUPLICATE_WINDOW_MS) {
        console.warn('[SnapGRID] Duplicate alert suppressed:', text);
        return;
      }

      recentAlerts.set(text, now);
      nativeAlert(message);
    };

    (window as any).__snapgridAlertLoopGuardInstalled = true;

    return () => {
      window.alert = nativeAlert;
      delete (window as any).__snapgridAlertLoopGuardInstalled;
    };
  }, []);

  return null;
}
